import { render, staticRenderFns } from "./ChatMessageForm.vue?vue&type=template&id=f5bd6872&"
import script from "./ChatMessageForm.vue?vue&type=script&lang=js&"
export * from "./ChatMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports